module.exports = __webpack_public_path__ + "img/hr-cliff-inner-shadow.7005e1ad.png";